import { LocalStorageService } from './../../../../../core/services/local-storage.service';
import { ClientfinalCraService } from './../../../../../core/services/clientfinal-cra/clientfinal-cra.service';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-detailworkflowclient',
  templateUrl: './detailworkflowclient.component.html',
  styleUrls: ['./detailworkflowclient.component.css'],
})
export class DetailworkflowclientComponent {
  company_id: any;
  roleConsultant:string="Collaborateur"

  id = this.activatedRoute.snapshot.params['id'];
  namesub: any;
  name = [
    { id: 1, name: 'Consultant' },
    { id: 2, name: 'Responsable' },
    { id: 3, name: 'RH' },
  ];
  state = [
    { id: 1, name: 'Validé' },
    { id: 2, name: 'Rejeté' },
  ];
  selectedworkflow: any;
  workflow: any;
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private activatedRoute: ActivatedRoute,
    private serviceCraclient: ClientfinalCraService,
    private spinner: NgxSpinnerService,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.company_id = this.localStorageService.getData('clientConnected');
    this.getWorkflowById();
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.id = params.params['id'];
        this.getWorkflowById();
      },
    });
  }

  // getWorkflowById() {
  //   this.spinner.show();
  //   this.serviceCraEsn.getWorkflowdetail(this.id).pipe(takeUntil(this.unsubscribeAll)).subscribe({
  //     next: (res) => {
  //       console.log("resworkflow detail ", res);
  //       this.selectedworkflow = res.data;
  //       console.log("resworkflow detail sqds ", this.selectedworkflow);
  //       console.log("reswl sqds ", this.selectedworkflow.name);

  //       this.spinner.hide();
  //     },
  //     error: () => {
  //       this.spinner.hide();
  //     },
  //   });
  // }
  getWorkflowById() {
    this.spinner.show();
    this.serviceCraclient
      .getWorkflowdetail(this.id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('resworkflow detail ', res);
          this.selectedworkflow = res.data;

          // this.selectedworkflow.sub_work_flow.forEach((subWorkFlowItem: any) => {
          //     console.log("Name: ", subWorkFlowItem.name);
          //     this.namesub = subWorkFlowItem.name;
          //     this.state = subWorkFlowItem.state;
          //     console.log("Nameeee: ", this.namesub);
          // });

          this.spinner.hide();
        },
        error: (err) => {
          console.error('Error fetching workflow: ', err);
          this.spinner.hide();
        },
      });
  }

  getSubWorkflowName(subWorkFlowItem: any): string {
    switch (subWorkFlowItem.name) {
      case '1':
        return 'Consultant';
      case '2':
        return 'Responsable';
      case '3':
        return 'RH';
      default:
        return '';
    }
  }
  getSubWorkflowState(subWorkFlowItem: any): string {
    switch (subWorkFlowItem.state) {
      case '1':
        return 'Validé';
      case '2':
        return 'Rejeté';

      default:
        return '';
    }
  }
}
